import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { Config } from 'src/app/models/configuration.model';
import { ContentService } from 'src/app/services/content.service';
import { DrawingContactService } from 'src/app/services/drawing-contact.service';
import { DrawingService } from 'src/app/services/drawing.service';
import { MultimodalService } from 'src/app/services/multimodal.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: [ './../navigation/navigation.component.css', './contact.component.css']
})
export class ContactComponent implements OnInit {

  contact_info: any = null;
  current_year = new Date().getFullYear();

  config: Config;

  constructor(private contentService: ContentService, private multimodalService: MultimodalService, private drawingContactService: DrawingContactService) {
    this.config = this.multimodalService.config;

    this.drawingContactService.playClick.subscribe(res => {
      this.multimodalService.playAudioClick();
    });

    this.drawingContactService.playMechanicalClick.subscribe(res => {
      this.multimodalService.playMechanicalClick();
    });

    this.drawingContactService.hapticFeedback.subscribe(res => {
      this.multimodalService.playHapticButtonClick(res);
    });

    this.config.activePage = 'contact';
  }


  ngOnInit() {
    this.contentService.getContactInfo().subscribe(res => {
      this.contact_info = res;
    });
    this.drawingContactService.draw();
  }

  linkTo(url: string) {
    this.multimodalService.playAudioClick();
    this.multimodalService.playHapticButtonClick(150);
    window.open(url);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.drawingContactService.draw();
  }



}
